import Icon from '../Icon.vue'

Icon.register({
  'success': {
    width: 20,
    height: 20,
    paths: [
      {
        d: 'M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm2.583-14.385l-3.744 5.99-1.607-1.607a1.308 1.308 0 00-1.849 1.85l2.77 2.769a1.308 1.308 0 002.033-.232L14.8 7.001a1.308 1.308 0 10-2.218-1.386h.001z'
      }
    ]
  }
})
